import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { SettingsConfirmTemplate } from 'components/Templates'
import { useSelector } from 'react-redux'
import { State } from 'index'

const ShopInformationConfirm: FC = () => {
  const path = useSelector((state: State) => state.router.location.pathname)
  const isConfirmPage = /\/admin\/shops\/.+\/information\/confirm/.test(path)
  const storeId = isConfirmPage ? path.split('/admin/shops/')[1].split('/information/confirm')[0] : undefined
  return (
    <Layout title={'確認 | 店舗基本情報を編集'}>
      <SettingsConfirmTemplate storeId={storeId} page={'shop'} />
    </Layout>
  )
}

export default ShopInformationConfirm
